var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "tiktok_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#tiktok_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 6v28h28V6H6Zm3.111 3.111H30.89V30.89H9.11V9.11ZM20 12.222v10.89a1.53 1.53 0 0 1-1.556 1.555 1.53 1.53 0 0 1-1.555-1.556 1.53 1.53 0 0 1 1.555-1.555v-3.112c-2.558 0-4.666 2.108-4.666 4.667 0 2.559 2.108 4.667 4.666 4.667 2.56 0 4.667-2.108 4.667-4.667v-5.86c.959.682 1.959 1.193 3.111 1.193v-3.11c-.073 0-1.147-.341-1.896-.994-.748-.653-1.215-1.472-1.215-2.118H20Z"
}))));
export default SvgTiktok;